<div class="row mb-md-3 section-fav">
  <div class="col-md-12">
    <ng-container *ngIf="onMobileView === false">
      <div class="row d-none d-md-block">
        <h2 class="col-md-12 text-left mb-2">Favoriten</h2>
        <p class="col-md-6">
          Du kannst Teams und Ligen zu deinen Favoriten hinzufügen.
          Um deine Favoriten speichern zu können, musst du dich registrieren.
        </p>
      </div>

      <!--  UI when searching  -->
      <div class="row searchbar-wrapper">
        <app-searchbar (searchStringChanged)="searchStringChanged($event)"
                       class="col-md-6 home-searchbar"
                       styleMode="onHomeContent"
                       [placeholder]="'Suche nach Teams oder Ligen'"></app-searchbar>
        <div class="register-club col-md-6">
          <a class="register-club__wrapper" [href]="registerYourClubLink">
            <span>Melde deinen Verein an</span>
          </a>
        </div>
      </div>

      <div class="row" *ngIf="isLoading === true">
        <div class="container mb-1 mt-1" style="min-height: 300px;">
          <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
        </div>
      </div>

      <ng-container *ngIf="showSearchResults === true && isLoading === false">
        <div class="row margin-bottom">
          <div class="col-12">
            <ng-container *ngIf="teams.length > 0">
              <h4>Teams mit dem Namen "{{searchString}}"</h4>
              <div class="grid">
                <ng-container *ngFor="let team of teams">
                  <app-search-cell [team]="team.team"></app-search-cell>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <ng-container *ngIf="leagues.length > 0">
              <h4>Ligen mit dem Namen "{{searchString}}"</h4>
              <div class="grid">
                <ng-container *ngFor="let league of leagues">
                  <app-search-cell [league]="league.league"></app-search-cell>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="row" *ngIf="leagues.length === 0 && teams.length === 0">
          <div class="col-12">
            <p class="no-infos-available">
              Keine Ligen und Teams gefunden
            </p>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="onMobileView === true">
      <div class="row" *ngIf="isLoading === true">
        <div class="container mb-1 mt-1" style="min-height: 300px;">
          <mat-spinner strokeWidth="2" color="primary" diameter="54" class="m-auto"></mat-spinner>
        </div>
      </div>
    </ng-container>

    <!--  UI when clicking throw leagues  -->
    <div class="row" *ngIf="showSearchResults === false" [class.d-none]="isLoading === true">
      <div class="col-md-12" [class.invisible]="selectedStateId != null">
        <app-search-start (stateSelected)="stateSelected($event)" [onMobileView]="onMobileView"></app-search-start>
      </div>
      <ng-container *ngIf="selectedStateId != null">
        <div class="col-md-12">
          <app-search-state-selected-component [stateId]="selectedStateId"
                                               [leagueId]="selectedLeagueId"
                                               [selectedSex]="selectedSex"
                                               [onMobileView]="onMobileView"
                                               (onSexSelected)="onSexSelected($event)"
                                               (onLeagueSelected)="onLeagueSelected($event)"
                                               (onFinishedLoading)="onFinishedLoading($event)"
                                               (onGoBack)="onGoBack($event)"
          ></app-search-state-selected-component>
        </div>
      </ng-container>
    </div>
  </div>
</div>
